export const PREFERRED_LANGUAGE_COOKIE_KEY = 'preferred_language';
